export const getRef = (element) => {
  if (typeof element === 'object' && Array.isArray(element)) {
    return element.length ? element[0] : []
  }
  return element
}
